import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@progress/kendo-react-dialogs';
import I18n, { translate } from '@utils/i18n';
import api from '@utils/axios';
import toast from 'react-hot-toast';
import { markAsPublishedInvoicesPath } from 'routes';

const namespace = 'features.invoices.index.mass_actions';

function PublishToCustomerPortal({ invoiceIds, invoicesCount, disabled, queryParams, onSuccess }) {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggleDialog = () => {
    setVisible(!visible);
  };

  const onSubmit = useCallback(async () => {
    setLoading(true);
    let params = new URLSearchParams();

    if (invoiceIds) {
      const idsArray = invoiceIds.split(',');
      idsArray.forEach((id) => params.append('ids[]', id.trim()));
      params = params.toString();
    } else {
      params = queryParams;
    }

    const url = `${markAsPublishedInvoicesPath({ format: 'json' })}?${params}`;

    try {
      const response = await api.get(url);
      toast.success(response.data.message);
      setVisible(false);
      // Trigger data refresh without page reload
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || I18n.t('invoices.publish_invoices_error');
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [invoiceIds, queryParams, onSuccess]);

  return (
    <>
      <button type="button" className="qmb-control" disabled={disabled} onClick={toggleDialog}>
        <i className="fa-light fa-arrow-right-to-bracket" />
        {translate('publish_to_customer_portal', { namespace })}
      </button>
      {visible && (
        <Dialog title={I18n.t('generic.confirm')} className="qmb-dialog" onClose={toggleDialog} closeIcon={!loading}>
          {I18n.t('invoices.publish_invoices_confirm')}

          <div className="modal__footer pull-right" style={{ justifyContent: 'space-between' }}>
            <div className="mt-3">
              <button type="button" className="qmb-button" onClick={toggleDialog} disabled={loading}>
                {I18n.t('generic.cancel')}
              </button>
              <button type="button" className="qmb-button--submit" onClick={onSubmit} disabled={loading}>
                {I18n.t('generic.ok')}
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
}

PublishToCustomerPortal.propTypes = {
  invoiceIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  invoicesCount: PropTypes.number.isRequired,
  queryParams: PropTypes.object.isRequired,
  onSuccess: PropTypes.func
};

PublishToCustomerPortal.defaultProps = {
  invoiceIds: null,
  onSuccess: null
};

export default PublishToCustomerPortal;
